(function () {
  var STORAGE_KEY = 'penny:scrollPosition';

  function saveScrollPosition() {
    var data = {
      url: window.location.href,
      scrollY: window.scrollY || window.pageYOffset,
      timestamp: Date.now(),
    };
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (_) {}
  }

  function restoreScrollPosition() {
    var raw;
    try {
      raw = sessionStorage.getItem(STORAGE_KEY);
    } catch (_) {
      return;
    }
    if (!raw) return;

    var data;
    try {
      data = JSON.parse(raw);
    } catch (_) {
      return;
    }

    if (
      !data ||
      typeof data.scrollY !== 'number' ||
      typeof data.url !== 'string' ||
      typeof data.timestamp !== 'number'
    ) {
      return;
    }

    // Only restore if navigating back within 30 minutes
    if (Date.now() - data.timestamp > 30 * 60 * 1000) {
      clearScrollPosition();
      return;
    }

    // The referrer check ensures we only restore on back-navigation
    var referrer = document.referrer ? new URL(document.referrer).pathname : '';
    var current = new URL(window.location.href).pathname;

    if (!referrer || referrer === current) return;

    // Delay to let DOM settle
    requestAnimationFrame(function () {
      window.scrollTo({ top: data.scrollY, behavior: 'instant' });
    });

    clearScrollPosition();
  }

  function clearScrollPosition() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
  }

  // Capture scroll before leaving for a product page
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    // Only capture when it's the same origin
    if (link.hostname !== window.location.hostname) return;
    saveScrollPosition();
  });

  // Restore on page load if coming from a product page
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreScrollPosition);
  } else {
    restoreScrollPosition();
  }

  // Also save on page unload as a fallback
  window.addEventListener('beforeunload', saveScrollPosition);
})();
